// Sub‑reducer for the `prescriptionsScheduleStep` slice – normalized prescriptions.
import {
  ACTION_TYPES,
  getAsyncActionTypeFulfiled
  // Ajuste para calculo de frequencia
  // getAsyncActionTypePending,
  // getAsyncActionTypeReject
} from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import STATUS from '../../constants/status.constant';

const { FETCH_PAD_DATA, UPDATE_SCHEDULE_PRESCRIPTION, RESET } = ACTION_TYPES;

const initialState = () => ({
  ids: [],
  byPrescriptionId: {},
  status: STATUS.IDLE,
  error: null
});

/**
 * Normalizes an array of prescription objects into a map keyed by id.
 */
const normalizePrescriptions = prescriptionsArray => {
  const byPrescriptionId = {};
  prescriptionsArray.forEach(p => {
    if (p.id) {
      byPrescriptionId[p.id] = { ...p };
    }
  });
  return {
    ids: Object.keys(byPrescriptionId),
    byPrescriptionId,
    status: STATUS.IDLE,
    error: null
  };
};

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    // Ajuste para calculo de frequencia
    // case getAsyncActionTypePending(UPDATE_SCHEDULE_PRESCRIPTION): {
    //   return { ...state, status: STATUS.LOADING, error: null };
    // }
    // case getAsyncActionTypeReject(UPDATE_SCHEDULE_PRESCRIPTION): {
    //   return { ...state, status: STATUS.FAILED, error: action.error };
    // }
    case UPDATE_SCHEDULE_PRESCRIPTION: {
      const prescriptionsArray = action.payload || [];
      return normalizePrescriptions(prescriptionsArray);
    }
    // Ajuste para calculo de frequencia
    // case UPDATE_SCHEDULE_PRESCRIPTION: {
    //   const prescriptionsArray = action.payload || [];
    //   return {
    //     ...normalizePrescriptions(prescriptionsArray),
    //     status: STATUS.SUCCEEDED,
    //     error: null
    //   };
    // }
    case getAsyncActionTypeFulfiled(FETCH_PAD_DATA): {
      const pad = action.payload;
      const prescriptions = pad.padPrescriptions || [];

      return normalizePrescriptions(prescriptions);
    }
    case RESET:
      return initialState();
    default:
      return state;
  }
};

export default reducer;
